module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repost-comp repost-music"
  }, [(_vm.showBanner) ? _c('div', {
    staticClass: "repost-banner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "repost-banner-close",
    on: {
      "click": function($event) {
        _vm.closeBanner()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/cross.svg"),
      "width": "15px"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.viewAllPlaylist) ? _c('div', {
    staticClass: "playlists"
  }, [_c('div', {
    staticClass: "title dflex align-center _intro"
  }, [_c('div', [_vm._v(_vm._s(_vm.playlistLen()) + " Playlists")]), _vm._v(" "), _c('div', {
    staticClass: "_action",
    on: {
      "click": function($event) {
        _vm.displayAllPlaylists()
      }
    }
  }, [_vm._v("View All")])]), _vm._v(" "), _c('div', {
    staticClass: "dflex playlist-container"
  }, _vm._l((this.playlists.slice(0, 6).reverse()), function(playlist, index) {
    return _c('div', {
      key: index,
      staticClass: "playlist-holder"
    }, [_c('v-btn', {
      staticClass: "absolute",
      attrs: {
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.openDeletePlaylistModal(playlist.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "right": ""
      }
    }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('div', {
      staticClass: "playlist-box",
      on: {
        "click": function($event) {
          _vm.$router.push({
            path: ("/playlist/" + (playlist.id))
          })
        }
      }
    }, [_c('div', {
      staticClass: "playlist-images"
    }, [_c('ul', _vm._l((_vm.playlistImageList(playlist)), function(playlistImage, index) {
      return _c('li', {
        key: index
      }, [_c('img', {
        attrs: {
          "src": playlistImage,
          "width": "30",
          "alt": "playlist icon"
        }
      })])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "playlist-text"
    }, [_vm._v("\n\t\t\t\t\t\t " + _vm._s(playlist.name) + "\n\t\t\t\t\t\t")])])], 1)
  }))]) : _vm._e(), _vm._v(" "), (!_vm.viewAllPlaylist) ? _c('div', {
    staticClass: "music playlist-music"
  }, [_c('div', {
    staticClass: "title _intro text-capitalize"
  }, [_vm._v(_vm._s(_vm.streams.length) + " " + _vm._s(_vm._f("pluralize")("video", _vm.streams.length)))]), _vm._v(" "), _c('div', {
    staticClass: "title dflex align-center justify-space-between _intro"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between w-100"
  }, [_c('input', {
    staticClass: "input-track",
    attrs: {
      "type": "text",
      "placeholder": "Search videos"
    }
  }), _vm._v(" "), (_vm.selectVideosMode) ? _c('div', {
    staticClass: "selectAlbumsMode _action"
  }, [_c('v-btn', {
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.openAddToPlaylist()
      }
    }
  }, [_vm._v(" Add selected to... ")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.toggleSelectVideosMode(false)
      }
    }
  }, [_vm._v(" Cancel ")])], 1) : _c('div', [_c('v-btn', {
    staticClass: "dflex align-center _action pointer-cursor font-bold",
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSelectVideosMode(true)
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('span', [_vm._v("Select Videos")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "list-track-view list-track-view-trackCard list-track-view-video listings"
  }, _vm._l((_vm.tempVideo), function(video, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item listing cursor-none"
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "getCollections": _vm.getCollections,
        "item": video,
        "showUsername": "",
        "forCollection": "",
        "hideUser": true,
        "sideTabView": true
      }
    }), _vm._v(" "), (_vm.selectVideosMode) ? _c('div', {
      staticClass: "selectMusic"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedVideos),
        expression: "selectedVideos"
      }],
      staticClass: "selectMusic-check",
      attrs: {
        "type": "checkbox",
        "id": ("check-" + index)
      },
      domProps: {
        "value": video,
        "checked": Array.isArray(_vm.selectedVideos) ? _vm._i(_vm.selectedVideos, video) > -1 : (_vm.selectedVideos)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedVideos,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = video,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedVideos = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedVideos = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedVideos = $$c
          }
        }
      }
    }), _vm._v(" "), (_vm.selectedVideos.includes(video)) ? _c('v-icon', {
      staticClass: "check-icon",
      on: {
        "click": function($event) {
          _vm.removeVideo(video.id)
        }
      }
    }, [_vm._v("\n              check\n            ")]) : _vm._e()], 1) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.viewAllPlaylist) ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": ""
    }
  }, [_c('div', {
    staticClass: "playlists"
  }, [_c('div', {
    staticClass: "title dflex align-center _intro"
  }, [_c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "ripple": true,
      "fab": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-5"
  }, [_vm._v(_vm._s(_vm.playlistLen()) + " Playlists")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dflex playlist-container"
  }, _vm._l((this.playlists), function(playlist, index) {
    return _c('div', {
      key: index,
      staticClass: "playlist-holder pr-2",
      on: {
        "click": function($event) {
          _vm.$router.push({
            path: ("/playlist/" + (playlist.id))
          })
        }
      }
    }, [_c('div', {
      staticClass: "playlist-box"
    }, [_c('div', {
      staticClass: "playlist-images"
    }, [_c('ul', _vm._l((_vm.playlistImageList(playlist)), function(playlistImage, index) {
      return _c('li', {
        key: index
      }, [_c('img', {
        attrs: {
          "src": playlistImage,
          "width": "30",
          "alt": "playlist icon"
        }
      })])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "playlist-text"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(playlist.name) + "\n\t\t\t\t\t\t\t")])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.addToPlaylistActive) ? _c('add-to-playlist', {
    attrs: {
      "playlists": this.playlists,
      "addToPlaylist": _vm.addToPlaylistActive,
      "selectedItems": this.selectedVideos,
      "type": "stream"
    },
    on: {
      "closeAddToPlaylist": _vm.closeAddToPlaylist,
      "methodThatForcesUpdate": _vm.methodThatForcesUpdate
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex gap-25 align-center justify-space-between"
  }, [_c('div', {
    staticClass: "repost-content"
  }, [_c('div', {
    staticClass: "dflex align-center mb-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/build-icon.svg"),
      "width": "25"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "repost-head"
  }, [_vm._v("Build your collection")])]), _vm._v(" "), _c('p', {
    staticClass: "repost-text"
  }, [_vm._v("Create playlists or shopping lists for all of the albums, videos & products you discover")])]), _vm._v(" "), _c('div', {
    staticClass: "repost-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/music-drop.gif"),
      "width": "100%"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b33b5fe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/collection/repostVideos.vue
// module id = 1605
// module chunks = 180